import { nonSeeded } from "../fable_modules/fable-library.4.1.4/Random.js";
import { isNullOrWhiteSpace, split, compare as compare_1, join, printf, toText } from "../fable_modules/fable-library.4.1.4/String.js";
import { FSharpRef, Union, Record, toString as toString_1, FSharpException } from "../fable_modules/fable-library.4.1.4/Types.js";
import { int32_type, tuple_type, union_type, list_type, unit_type, string_type, record_type, option_type, lambda_type, class_type } from "../fable_modules/fable-library.4.1.4/Reflection.js";
import { FSharpMap__get_Item, add, tryFind, empty } from "../fable_modules/fable-library.4.1.4/Map.js";
import { curry2, uncurry2, structuralHash, equals, comparePrimitives, max, min, compare } from "../fable_modules/fable-library.4.1.4/Util.js";
import { some, defaultArg, ofNullable, bind, value as value_3 } from "../fable_modules/fable-library.4.1.4/Option.js";
import { fold as fold_1, reduce, min as min_1, map as map_2, max as max_1, collect, delay, toList, length, skip, head as head_1 } from "../fable_modules/fable-library.4.1.4/Seq.js";
import { item as item_1, length as length_1, foldBack, take, fold, append, contains, exists, singleton, collect as collect_1, cons, empty as empty_1, reverse, ofArray, initialize, ofSeq, tail as tail_1, head as head_2, isEmpty } from "../fable_modules/fable-library.4.1.4/List.js";
import { iterateIndexed, map as map_1 } from "../fable_modules/fable-library.4.1.4/Array.js";
import { FSharpSet__Contains, ofSeq as ofSeq_1 } from "../fable_modules/fable-library.4.1.4/Set.js";
import { rangeChar } from "../fable_modules/fable-library.4.1.4/Range.js";
import { isLetterOrDigit } from "../fable_modules/fable-library.4.1.4/Char.js";
import { FSharpResult$2 } from "../fable_modules/fable-library.4.1.4/Choice.js";

export function flip(f, x, y) {
    return f(y, x);
}

export const random = nonSeeded();

export function rand(x) {
    return 1 + random.Next1(x);
}

export function thunk(v, _arg) {
    return v;
}

export function thunk1(f, arg, _arg) {
    return f(arg);
}

export function thunk2(f, arg1, arg2, _arg) {
    return f(arg1, arg2);
}

export function thunk3(f, arg1, arg2, arg3, _arg) {
    return f(arg1, arg2, arg3);
}

export function tuple2(x, y) {
    return [x, y];
}

export function matchfail(v) {
    throw new Error(toText(printf("No match found for %A. This is a bug."))(v));
}

export function ignoreM(_arg, monad) {
    return [void 0, monad];
}

export class BugException extends FSharpException {
    constructor(msg) {
        super();
        this.msg = msg;
    }
}

export function BugException_$reflection() {
    return class_type("Common.BugException", void 0, BugException, class_type("System.Exception"));
}

/**
 * Placeholder while we're doing type-focused development, before implementation
 */
export function notImpl(v) {
    throw new Error(`Not implemented yet. Email Max if you want this feature. ${v}`);
}

export function shouldntHappen(arg) {
    throw new BugException(`This shouldn't ever happen. If it does there's a bug. Details: ${arg}`);
}

export function breakHere() {
    debugger;
}

export function viaAny() {
    return [(value) => value, (value_1) => value_1];
}

export function memoize(f) {
    let cache = empty({
        Compare: compare,
    });
    return (x_1) => {
        const matchValue = tryFind(x_1, cache);
        if (matchValue == null) {
            const v_1 = f(x_1);
            cache = add(x_1, v_1, cache);
            return v_1;
        }
        else {
            return value_3(matchValue);
        }
    };
}

export const emptyString = "";

export function toString(x) {
    let copyOfStruct = x;
    return toString_1(copyOfStruct);
}

export function betweenInclusive(a, b, n) {
    if (compare(min(compare, a, b), n) <= 0) {
        return compare(n, max(compare, a, b)) <= 0;
    }
    else {
        return false;
    }
}

/**
 * invoke f without requiring parens
 */
export function inv(f) {
    return f();
}

export function chooseRandom(options) {
    return head_1(skip(random.Next1(length(options)), options));
}

export function chooseRandomExponentialDecay(acceptRate, fallback, options) {
    const recur = (_arg_mut) => {
        recur:
        while (true) {
            const _arg = _arg_mut;
            if (isEmpty(_arg)) {
                return fallback(options);
            }
            else if (random.NextDouble() < acceptRate) {
                return head_2(_arg);
            }
            else {
                _arg_mut = tail_1(_arg);
                continue recur;
            }
            break;
        }
    };
    return recur(ofSeq(options));
}

export function chooseWeightedRandom(options) {
    return chooseRandom(toList(delay(() => collect((matchValue) => initialize(matchValue[0], (arg10$0040) => thunk(matchValue[1], arg10$0040)), options))));
}

export function iter(data, f) {
    data.contents = f(data.contents);
    return data.contents;
}

/**
 * iter and ignore the result
 */
export function iteri(data, f) {
    data.contents = f(data.contents);
}

export function shuffleCopy() {
    return (a_1) => {
        const a_2 = map_1((x_1) => x_1, a_1);
        iterateIndexed((i, _arg) => {
            const a = a_2;
            const x = i | 0;
            const y = random.Next2(i, a_2.length) | 0;
            const tmp = a[x];
            a[x] = a[y];
            a[y] = tmp;
        }, a_2);
        return a_2;
    };
}

export function Tuple2_create(x, y) {
    return [x, y];
}

export function Tuple2_mapfst(f, x, y) {
    return [f(x), y];
}

export function Tuple2_mapsnd(f, x, y) {
    return [x, f(y)];
}

export function Tuple2_ofList(_arg) {
    let matchResult, x, y;
    if (!isEmpty(_arg)) {
        if (!isEmpty(tail_1(_arg))) {
            if (isEmpty(tail_1(tail_1(_arg)))) {
                matchResult = 0;
                x = head_2(_arg);
                y = head_2(tail_1(_arg));
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return [x, y];
        default:
            return shouldntHappen("Tuple2.ofList: list must have exactly 2 elements");
    }
}

export function Tuple2_toList(x, y) {
    return ofArray([x, y]);
}

export class Ctor_AnonymousConstructor$2 extends Record {
    constructor(create, extract) {
        super();
        this.create = create;
        this.extract = extract;
    }
}

export function Ctor_AnonymousConstructor$2_$reflection(gen0, gen1) {
    return record_type("Common.Ctor.AnonymousConstructor`2", [gen0, gen1], Ctor_AnonymousConstructor$2, () => [["create", lambda_type(gen0, gen1)], ["extract", lambda_type(gen1, option_type(gen0))]]);
}

export class Ctor_Constructor$2 extends Record {
    constructor(create, extract, name) {
        super();
        this.create = create;
        this.extract = extract;
        this.name = name;
    }
}

export function Ctor_Constructor$2_$reflection(gen0, gen1) {
    return record_type("Common.Ctor.Constructor`2", [gen0, gen1], Ctor_Constructor$2, () => [["create", lambda_type(gen0, gen1)], ["extract", lambda_type(gen1, option_type(gen0))], ["name", string_type]]);
}

export function Ctor_Constructor$2_op_EqualsGreater_Z21F51440(lhs, rhs) {
    return new Ctor_Constructor$2((arg) => rhs.create(lhs.create(arg)), (arg_1) => bind(lhs.extract, rhs.extract(arg_1)), `${rhs.name} (${lhs.name})`);
}

export function Ctor_Constructor$2_op_EqualsGreater_Z6EAB6A2D(lhs, rhs) {
    return new Ctor_Constructor$2((arg) => rhs.create(lhs.create(arg)), (arg_1) => bind(lhs.extract, rhs.extract(arg_1)), lhs.name);
}

export function Ctor_Constructor$2_op_EqualsGreater_Z137C79CD(lhs, rhs) {
    return new Ctor_Constructor$2((arg) => rhs.create(lhs.create(arg)), (arg_1) => bind(lhs.extract, rhs.extract(arg_1)), rhs.name);
}

export function Ctor_ctor(create, extract) {
    return new Ctor_AnonymousConstructor$2(create, extract);
}

export function Ctor_namedCtor(name, create, extract) {
    return new Ctor_Constructor$2(create, extract, name);
}

export class Ops {
    constructor() {
    }
}

export function Ops_$reflection() {
    return class_type("Common.Ops", void 0, Ops);
}

export function Ops_add_1F6216BE(key, value, data) {
    return add(key, value, data);
}

export function Ops_addTo_2FBA9827(data) {
    return (key) => ((value) => Ops_add_1F6216BE(key, value, data));
}

export function String_oxfordJoin(_arg) {
    if (isEmpty(_arg)) {
        return emptyString;
    }
    else if (isEmpty(tail_1(_arg))) {
        return head_2(_arg);
    }
    else if (isEmpty(tail_1(tail_1(_arg)))) {
        return toText(printf("%s and %s"))(head_2(_arg))(head_2(tail_1(_arg)));
    }
    else {
        const matchValue = reverse(_arg);
        if (!isEmpty(matchValue)) {
            const arg = join(", ", reverse(tail_1(matchValue)));
            return toText(printf("%s, and %s"))(arg)(head_2(matchValue));
        }
        else {
            return shouldntHappen(void 0);
        }
    }
}

export function String_join(delimiter, strings) {
    return join(delimiter, strings);
}

export function String_equalsIgnoreCase(lhs, rhs) {
    return compare_1(lhs, rhs, 3) === 0;
}

export function String_firstWord(input) {
    const matchValue = ofNullable(input);
    if (matchValue == null) {
        return input;
    }
    else {
        const v = matchValue;
        return head_1(split(v.trim(), [" "], void 0, 0));
    }
}

export function String_trim(s) {
    return s.trim();
}

export function String_isntWhitespace(s) {
    return !isNullOrWhiteSpace(s);
}

export const String_uncamel = memoize((str) => {
    const caps = ofSeq_1(toList(rangeChar("A", "Z")), {
        Compare: comparePrimitives,
    });
    const lower = ofSeq_1(toList(rangeChar("a", "z")), {
        Compare: comparePrimitives,
    });
    let spaceNeededBefore = empty_1();
    let inWord = true;
    for (let i = 1; i <= (str.length - 1); i++) {
        const matchValue = str[i];
        if (matchValue === " ") {
            inWord = false;
        }
        else if ((FSharpSet__Contains(caps, matchValue) && inWord) && (!FSharpSet__Contains(caps, str[i - 1]) ? true : (((i + 1) < str.length) && FSharpSet__Contains(lower, str[i + 1])))) {
            spaceNeededBefore = cons(i, spaceNeededBefore);
        }
        else if (isLetterOrDigit(matchValue)) {
            inWord = true;
        }
    }
    const recur = (workingCopy_mut, spacesNeeded_mut) => {
        recur:
        while (true) {
            const workingCopy = workingCopy_mut, spacesNeeded = spacesNeeded_mut;
            if (!isEmpty(spacesNeeded)) {
                const index = head_2(spacesNeeded) | 0;
                workingCopy_mut = (`${workingCopy.slice(0, (index - 1) + 1)} ${workingCopy.slice(index, workingCopy.length)}`);
                spacesNeeded_mut = tail_1(spacesNeeded);
                continue recur;
            }
            else {
                return workingCopy;
            }
            break;
        }
    };
    return recur(str, spaceNeededBefore);
});

export function System_Object__Object_ToUncameledString(this$) {
    return String_uncamel(toString_1(this$));
}

export function List_join(delimiter, lst) {
    let matchResult, head, tail;
    if (!isEmpty(lst)) {
        if (isEmpty(tail_1(lst))) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
            head = head_2(lst);
            tail = tail_1(lst);
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return lst;
        default:
            return cons(head, collect_1((x) => ofArray([delimiter, x]), tail));
    }
}

export function List_wrap(v) {
    return singleton(v);
}

export function List_ofOption(_arg) {
    if (_arg != null) {
        return singleton(value_3(_arg));
    }
    else {
        return empty_1();
    }
}

export function List_every(f) {
    return (arg_1) => !exists((arg) => !f(arg), arg_1);
}

export function List_includes(values) {
    return (list) => exists((v) => contains(v, values, {
        Equals: equals,
        GetHashCode: structuralHash,
    }), list);
}

export function List_tryMapFold(f_mut, state_mut, lst_mut) {
    List_tryMapFold:
    while (true) {
        const f = f_mut, state = state_mut, lst = lst_mut;
        if (!isEmpty(lst)) {
            const matchValue = f(state, head_2(lst));
            if (matchValue.tag === 0) {
                f_mut = f;
                state_mut = matchValue.fields[0];
                lst_mut = tail_1(lst);
                continue List_tryMapFold;
            }
            else {
                return matchValue;
            }
        }
        else {
            return new FSharpResult$2(0, [state]);
        }
        break;
    }
}

export function List_maxBy$0027(f, lst) {
    return max_1(map_2(f, lst), {
        Compare: compare,
    });
}

export function List_minBy$0027(f, lst) {
    return min_1(map_2(f, lst), {
        Compare: compare,
    });
}

export function List_prefixes(lst) {
    const recur = (_arg) => {
        if (!isEmpty(_arg)) {
            const t = tail_1(_arg);
            return cons(t, recur(t));
        }
        else {
            return empty_1();
        }
    };
    return cons(lst, recur(lst));
}

export function Map_keys(m) {
    return map_2((_arg) => _arg[0], m);
}

export function Map_values(m) {
    return map_2((_arg) => _arg[1], m);
}

export function Map_addForce(key, f, m) {
    const matchValue = tryFind(key, m);
    if (matchValue == null) {
        return add(key, f(empty({
            Compare: compare,
        })), m);
    }
    else {
        const v = matchValue;
        const v$0027 = f(v);
        if (v.Equals(v$0027)) {
            return m;
        }
        else {
            return add(key, v$0027, m);
        }
    }
}

export function Map_findForce(key, m) {
    return defaultArg(tryFind(key, m), empty({
        Compare: compare,
    }));
}

export function Map_$007CLookup$007C_$007C(key, map) {
    return tryFind(key, map);
}

export function Queue_append(item, queue) {
    return append(queue, singleton(item));
}

export function Queue_empty() {
    return empty_1();
}

export function Queue_read(queue) {
    return queue;
}

export function Ops_add_5CF4802(item, data) {
    return Queue_append(item, data);
}

export function Ops_addTo_5CDFDA7(data) {
    return (item) => Ops_add_5CF4802(item, data);
}

export function StateChangeMonad_getState(s) {
    return [s, s];
}

export function StateChangeMonad_putState(s, _arg) {
    return [void 0, s];
}

export function StateChangeMonad_eval(m, s) {
    return m(s)[0];
}

export function StateChangeMonad_exec(m, s) {
    return m(s)[1];
}

export function StateChangeMonad_empty(s) {
    return [void 0, s];
}

export function StateChangeMonad_bind(k, m, s) {
    const patternInput = m(s);
    return k(patternInput[0], patternInput[1]);
}

function StateChangeMonad_State_get(s) {
    return [s, s];
}

function StateChangeMonad_State_set(v, _arg) {
    return [void 0, v];
}

function StateChangeMonad_State_map(f, s, s0) {
    const patternInput = s(s0);
    return [f(patternInput[0]), patternInput[1]];
}

export class StateChangeMonad_StateBuilder {
    constructor() {
    }
}

export function StateChangeMonad_StateBuilder_$reflection() {
    return class_type("Common.StateChangeMonad.StateBuilder", void 0, StateChangeMonad_StateBuilder);
}

export function StateChangeMonad_StateBuilder_$ctor() {
    return new StateChangeMonad_StateBuilder();
}

export function StateChangeMonad_StateBuilder__Return_1505(this$, x) {
    return (state) => [x, state];
}

export function StateChangeMonad_StateBuilder__Zero(this$) {
    return (state) => StateChangeMonad_StateBuilder__zero_1505(this$, state);
}

export function StateChangeMonad_StateBuilder__ReturnFrom_1505(this$, stateful) {
    return stateful;
}

export function StateChangeMonad_StateBuilder__Bind_3179(this$, m, f) {
    return (s) => StateChangeMonad_StateBuilder__bind(this$, f, m, s);
}

export function StateChangeMonad_StateBuilder__Combine_419033D3(this$, m1, m2) {
    return (s) => StateChangeMonad_StateBuilder__bind(this$, uncurry2(() => m2), m1, s);
}

export function StateChangeMonad_StateBuilder__For_4BCC29DA(this$, seq, f) {
    return reduce((x1, x2) => StateChangeMonad_StateBuilder__Combine_419033D3(this$, x1, x2), map_2(curry2(f), seq));
}

export function StateChangeMonad_StateBuilder__Delay_Z38F4EA44(this$, f) {
    return (s) => StateChangeMonad_StateBuilder__bind(this$, f, (state) => StateChangeMonad_StateBuilder__zero_1505(this$, state), s);
}

export function StateChangeMonad_StateBuilder__While_Z13C36FDB(this$, condition, body) {
    return (state) => {
        const loop = (state_1_mut) => {
            loop:
            while (true) {
                const state_1 = state_1_mut;
                if (condition()) {
                    state_1_mut = body(state_1)[1];
                    continue loop;
                }
                else {
                    return [void 0, state_1];
                }
                break;
            }
        };
        return loop(state);
    };
}

export function StateChangeMonad_StateBuilder__bind(this$, k, m, s) {
    const patternInput = m(s);
    return k(patternInput[0], patternInput[1]);
}

export function StateChangeMonad_StateBuilder__zero_1505(this$, state) {
    return [void 0, state];
}

export function StateChangeMonad_get(unitVar, state) {
    return [state, state];
}

export function StateChangeMonad_getF(f, state) {
    return [f(state), state];
}

export function StateChangeMonad_transform(f, state) {
    return [void 0, f(state)];
}

export function StateChangeMonad_transform1(f, state) {
    const patternInput = f(state);
    return [patternInput[0], patternInput[1]];
}

export function StateChangeMonad_set(v, state) {
    return [void 0, v];
}

export const StateChangeMonad_stateChange = StateChangeMonad_StateBuilder_$ctor();

export function StateChangeMonad_runNoResult(state, stateChangeMonad) {
    return stateChangeMonad(state)[1];
}

export function StateChangeMonad_run(state, stateChangeMonad) {
    return stateChangeMonad(state);
}

export function withState(initialState, monad) {
    return monad(initialState)[0];
}

export function toState(initialState, monad) {
    return monad(initialState)[1];
}

class Delta_Seed$2 extends Union {
    constructor(initial, update) {
        super();
        this.tag = 0;
        this.fields = [initial, update];
    }
    cases() {
        return ["Seed"];
    }
}

function Delta_Seed$2_$reflection(gen0, gen1) {
    return union_type("Common.Delta.Seed`2", [gen0, gen1], Delta_Seed$2, () => [[["initial", lambda_type(unit_type, gen0)], ["update", lambda_type(list_type(gen1), lambda_type(gen1, lambda_type(gen0, gen0)))]]]);
}

export class Delta_DeltaDrivenState$2 extends Record {
    constructor(seed, current, past) {
        super();
        this.seed = seed;
        this.current = current;
        this.past = past;
    }
}

export function Delta_DeltaDrivenState$2_$reflection(gen0, gen1) {
    return record_type("Common.Delta.DeltaDrivenState`2", [gen0, gen1], Delta_DeltaDrivenState$2, () => [["seed", Delta_Seed$2_$reflection(gen0, gen1)], ["current", gen0], ["past", list_type(gen1)]]);
}

export function Delta_create(initial, update) {
    return new Delta_DeltaDrivenState$2(new Delta_Seed$2(initial, update), initial(), empty_1());
}

export function Delta_deref(this$) {
    return this$.current;
}

export function Delta_execute(msg, _arg) {
    const this$ = _arg;
    const past = this$.past;
    return new Delta_DeltaDrivenState$2(this$.seed, this$.seed.fields[1](past, msg, this$.current), cons(msg, past));
}

export function Delta_executeM(msg, state) {
    return [void 0, Delta_execute(msg, state)];
}

export function Delta_getM(f, state) {
    return [f(state.current), state];
}

export function Delta_transformM(f, state) {
    return [void 0, fold((x, y) => flip(Delta_execute, x, y), state, f(state.current))];
}

export function Delta_rewind(ix, state) {
    const patternInput = state.seed;
    const history = reverse(state.past);
    return fold((x, y) => flip(Delta_execute, x, y), Delta_create(patternInput.fields[0], patternInput.fields[1]), take(ix, history));
}

class SharedDelta_Seed$2 extends Union {
    constructor(initial, update) {
        super();
        this.tag = 0;
        this.fields = [initial, update];
    }
    cases() {
        return ["Seed"];
    }
}

function SharedDelta_Seed$2_$reflection(gen0, gen1) {
    return union_type("Common.SharedDelta.Seed`2", [gen0, gen1], SharedDelta_Seed$2, () => [[["initial", lambda_type(unit_type, gen0)], ["update", lambda_type(gen1, lambda_type(gen0, gen0))]]]);
}

export class SharedDelta_SharedDeltaDrivenState$2 extends Record {
    constructor(seed, shared, past, queue) {
        super();
        this.seed = seed;
        this.shared = shared;
        this.past = past;
        this.queue = queue;
    }
}

export function SharedDelta_SharedDeltaDrivenState$2_$reflection(gen0, gen1) {
    return record_type("Common.SharedDelta.SharedDeltaDrivenState`2", [gen0, gen1], SharedDelta_SharedDeltaDrivenState$2, () => [["seed", SharedDelta_Seed$2_$reflection(gen0, gen1)], ["shared", record_type("Microsoft.FSharp.Core.FSharpRef`1", [tuple_type(gen0, list_type(gen1))], FSharpRef, () => [["contents", tuple_type(gen0, list_type(gen1))]])], ["past", list_type(gen1)], ["queue", list_type(gen1)]]);
}

export function SharedDelta_create(initial, update) {
    return new SharedDelta_SharedDeltaDrivenState$2(new SharedDelta_Seed$2(initial, update), new FSharpRef([initial(), empty_1()]), empty_1(), empty_1());
}

export function SharedDelta_$007CDeref$007C(cell) {
    return cell.contents;
}

export function SharedDelta_derefM(_arg) {
    let matchResult, current_1, past_1, sharedPast_1, this$_1, current_2, init, past_2, queue, shared, sharedPast_2, this$_2, update;
    const activePatternResult = SharedDelta_$007CDeref$007C(_arg.shared);
    if (isEmpty(_arg.queue)) {
        if (equals(activePatternResult[1], _arg.past)) {
            matchResult = 0;
            current_1 = activePatternResult[0];
            past_1 = _arg.past;
            sharedPast_1 = activePatternResult[1];
            this$_1 = _arg;
        }
        else {
            matchResult = 1;
            current_2 = activePatternResult[0];
            init = _arg.seed.fields[0];
            past_2 = _arg.past;
            queue = _arg.queue;
            shared = _arg.shared;
            sharedPast_2 = activePatternResult[1];
            this$_2 = _arg;
            update = curry2(_arg.seed.fields[1]);
        }
    }
    else {
        matchResult = 1;
        current_2 = activePatternResult[0];
        init = _arg.seed.fields[0];
        past_2 = _arg.past;
        queue = _arg.queue;
        shared = _arg.shared;
        sharedPast_2 = activePatternResult[1];
        this$_2 = _arg;
        update = curry2(_arg.seed.fields[1]);
    }
    switch (matchResult) {
        case 0:
            return [current_1, this$_1];
        default: {
            const apply = (q, state) => foldBack(uncurry2(update), q, state);
            let patternInput;
            if (equals(sharedPast_2, past_2)) {
                patternInput = [apply(queue, current_2), append(queue, past_2)];
            }
            else {
                const combined = append(queue, past_2);
                patternInput = [apply(combined, init()), combined];
            }
            const past$0027 = patternInput[1];
            const current$0027 = patternInput[0];
            shared.contents = [current$0027, past$0027];
            return [current$0027, new SharedDelta_SharedDeltaDrivenState$2(this$_2.seed, shared, past$0027, empty_1())];
        }
    }
}

export function SharedDelta_execute(msg, _arg) {
    const this$ = _arg;
    return new SharedDelta_SharedDeltaDrivenState$2(this$.seed, this$.shared, this$.past, cons(msg, this$.queue));
}

export function SharedDelta_executeM(msg, state) {
    return [void 0, SharedDelta_execute(msg, state)];
}

export function SharedDelta_getM(f, state) {
    const patternInput = SharedDelta_derefM(state);
    return [f(patternInput[0]), patternInput[1]];
}

export function SharedDelta_transformM(f, state) {
    const patternInput = SharedDelta_derefM(state);
    return [void 0, fold((x, y) => flip(SharedDelta_execute, x, y), patternInput[1], f(patternInput[0]))];
}

export function ResizeArray_$007CLookup$007C_$007C(id, rows) {
    if (rows.length > id) {
        return some(rows[id]);
    }
    else {
        return void 0;
    }
}

export class FastList_d$1 extends Record {
    constructor(reversedOrder, randomAccess, cached) {
        super();
        this.reversedOrder = reversedOrder;
        this.randomAccess = randomAccess;
        this.cached = cached;
    }
}

export function FastList_d$1_$reflection(gen0) {
    return record_type("Common.FastList.d`1", [gen0], FastList_d$1, () => [["reversedOrder", list_type(gen0)], ["randomAccess", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, gen0])], ["cached", option_type(list_type(gen0))]]);
}

export function FastList_d$1__Add_2B595(lst, value) {
    return new FastList_d$1(cons(value, lst.reversedOrder), add(length_1(lst.reversedOrder), value, lst.randomAccess), void 0);
}

export function FastList_d$1__AddM_2B595(lst, value) {
    const ix = length_1(lst.reversedOrder) | 0;
    return [ix, new FastList_d$1(cons(value, lst.reversedOrder), add(ix, value, lst.randomAccess), void 0)];
}

export function FastList_d$1__inOrder(lst) {
    const matchValue = lst.cached;
    if (matchValue == null) {
        const rev = reverse(lst.reversedOrder);
        lst.cached = rev;
        return rev;
    }
    else {
        return matchValue;
    }
}

export function FastList_d$1__get_Item_Z524259A4(lst, ix) {
    return FSharpMap__get_Item(lst.randomAccess, ix);
}

export function FastList_d$1__get_Length(lst) {
    return length_1(lst.reversedOrder);
}

export function FastList_fresh() {
    return new FastList_d$1(empty_1(), empty({
        Compare: comparePrimitives,
    }), void 0);
}

export function FastList_add(value, lst) {
    return FastList_d$1__Add_2B595(lst, value);
}

export function FastList_addM(value, lst) {
    return FastList_d$1__AddM_2B595(lst, value);
}

export function FastList_ofSeq(values) {
    return fold_1((x, y) => flip(FastList_add, x, y), FastList_fresh(), values);
}

export function FastList_length(this$) {
    return length_1(this$.reversedOrder);
}

export function Trie_read(nav, ixs, trie) {
    const recur = (ixs_1_mut, node_mut) => {
        recur:
        while (true) {
            const ixs_1 = ixs_1_mut, node = node_mut;
            const matchValue = nav(node);
            if (!isEmpty(ixs_1)) {
                if (matchValue[1] == null) {
                    return void 0;
                }
                else {
                    const children = matchValue[1];
                    const ix_1 = ((head_2(ixs_1) < 0) ? (length_1(children) + head_2(ixs_1)) : head_2(ixs_1)) | 0;
                    if ((0 > ix_1) ? true : (ix_1 >= length_1(children))) {
                        return void 0;
                    }
                    else {
                        ixs_1_mut = tail_1(ixs_1);
                        node_mut = item_1(ix_1, children);
                        continue recur;
                    }
                }
            }
            else {
                return some(matchValue[0]);
            }
            break;
        }
    };
    return recur(ixs, trie);
}

export function Trie_replace(nav, navUpdate, targetNodeUpdate, ixs, trie) {
    const recur = (ixs_1, node) => {
        const matchValue = nav(node);
        if (!isEmpty(ixs_1)) {
            if (matchValue[1] == null) {
                return node;
            }
            else {
                const children = matchValue[1];
                const ix_1 = ((head_2(ixs_1) >= 0) ? head_2(ixs_1) : (length_1(children) + head_2(ixs_1))) | 0;
                if ((0 > ix_1) ? true : (ix_1 >= length_1(children))) {
                    return node;
                }
                else {
                    return navUpdate([ix_1, recur(tail_1(ixs_1), item_1(ix_1, children))], node);
                }
            }
        }
        else {
            return targetNodeUpdate(node);
        }
    };
    return recur(ixs, trie);
}

//# sourceMappingURL=Common.fs.js.map
